/**
 * The widget's two calls to next-sellwild's ports of PHP's session/rpc
 * (api.sellwild.com): the URL, method and body of each, kept apart from
 * Widget.tsx so they can be tested without a browser.
 *
 * The body is the old `params` object and the reply keeps { result: { rs } }.
 * A string body with no Content-Type goes as text/plain, so the browser skips
 * a preflight.
 */

export const SESSION_URL = 'https://sellwild.com/api/widget-feed/session'
export const LISTING_ACTION_URL = 'https://sellwild.com/api/widget-feed/listing-action'

export interface WidgetFeedRequest {
  url: string
  init: { method: 'POST', body: string }
}

/** createRemoteSession's request, for a reader Lotame has identified. */
export function remoteSessionRequest ({ lotameId, panoramaId, widgetCacheVersionId }: { lotameId?: string, panoramaId?: string, widgetCacheVersionId?: string }): WidgetFeedRequest {
  return {
    url: SESSION_URL,
    init: {
      method: 'POST',
      body: JSON.stringify({ trackingData: { lotameId, panoramaId }, widgetCacheVersionId }),
    },
  }
}

/** listingAction's request for a click: actionType '1' and membershipType as a string, as PHP took them. */
export function listingActionRequest ({ trackingData, listingId, membershipType }: { trackingData: { lotameId?: string, panoramaId?: string, userId?: string }, listingId: number, membershipType: string }): WidgetFeedRequest {
  return {
    url: LISTING_ACTION_URL,
    init: {
      method: 'POST',
      body: JSON.stringify({ trackingData, listingId, membershipType: String(membershipType), actionType: '1' }),
    },
  }
}
